// Invitanda pass 74 (2026-10-23): moved out of blocks/mb-variant-picker, where it was printed inline.

  (function () {
    if (window.__mbvpColor) return;
    window.__mbvpColor = true;
    // pass 54 (2026-10-18, the owner: "ko nhảy qua ảnh đúng color ... phải nhảy nhanh ko có độ chớp mắt"). A tap on a
    // color changes the photo of that option IN the gallery on screen, at the tap, and puts the slideshow on it at
    // once, with no slide. The gallery holds one photo of the option (the theme hides the other colors' photos); each
    // radio carries its variant's photo (data-mbvp-photo). Nothing waits for the theme's page of the new color (0.6 to
    // 1.7 s), and the gallery is not replaced when that page arrives: the replacement drew the main photo first, and on
    // Safari it often stayed there (pass 46 set initial-slide on it, Safari ignored it at the first tap).
    // The photos load ahead as real pictures in a hidden box, and the picture of the tapped color takes the place of the
    // one on screen (Safari loads a picture again when only its address changes, so a swap of addresses was not instant
    // there). Once the gallery's first photo is in, a 600 px copy of every color of an option of 12 values or fewer
    // loads, then the full sizes one by one; the color under the finger loads as the finger lands. A color whose full
    // size is not in yet shows its 600 px copy at once and sharpens when the full size is in; with neither in yet (a slow
    // line), the gallery stays where it is until one is (3 s at most), never on an empty frame. The thumbnails and the
    // zoom pictures take the new color's files; when the page of the new color arrives with the same photos, its texts
    // (alt, thumbnail labels) are copied and its gallery is dropped. A page with other photos goes in as before, opened on
    // the color's photo (pass 46). A size tap keeps the gallery (pass 44). A product card, a quick add, a dialog or a
    // featured product is left alone.
    var IDLE_MAX = 12, MID = 600, WAIT = 3000, ATTRS = ['src', 'srcset', 'data_max_resolution'];
    function file(u) { return String(u || '').split('?')[0].split('/').pop(); }
    // A photo's address without its size: path and version (the radio, the swatch and the gallery share both).
    function key(u) {
      var s = String(u || ''), q = s.indexOf('?'), m = s.match(/[?&]v=([^&]+)/);
      return m ? (q < 0 ? s : s.slice(0, q)) + '?v=' + m[1] : '';
    }
    function photoKey(inp) {
      if (!inp || !inp.getAttribute) return '';
      var k = key(inp.getAttribute('data-mbvp-photo')), l, im;
      if (k) return k;
      l = inp.closest ? inp.closest('label') : null;
      im = l && l.querySelector('img');
      return im ? key(im.getAttribute('src')) : '';
    }
    function okPicker(p) { return !!(p && p.closest && !p.closest('product-card, quick-add-dialog, dialog, featured-product-information')); }
    function galleryOf(p) { var s = p.closest('.shopify-section'); return s ? s.querySelector('media-gallery') : null; }
    function slides(g) { return g.querySelectorAll('slideshow-slide'); }
    function slideKey(sl) { var im = sl.querySelector('img'); return im ? key(im.getAttribute('src')) : ''; }
    function slideIndex(g, k) {
      var sl = slides(g), i;
      for (i = 0; i < sl.length; i++) if (k && slideKey(sl[i]) === k) return i;
      return -1;
    }
    function slideImg(g, k) { var i = slideIndex(g, k); return i >= 0 ? slides(g)[i].querySelector('img') : null; }
    function optionKeys(fs) {
      var ins = fs ? fs.querySelectorAll('input[type=radio]') : [], out = [], i, k;
      for (i = 0; i < ins.length; i++) { k = photoKey(ins[i]); if (k && out.indexOf(k) === -1) out.push(k); }
      return out;
    }
    // The photo of this option the gallery shows now.
    function shownKey(g, fs) {
      var ks = optionKeys(fs), i;
      for (i = 0; i < ks.length; i++) if (slideIndex(g, ks[i]) >= 0) return ks[i];
      return '';
    }
    function holders(g, k) {
      var all = g.querySelectorAll('img, source'), out = [], i, j, v;
      for (i = 0; i < all.length; i++) {
        for (j = 0; j < ATTRS.length; j++) {
          v = all[i].getAttribute(ATTRS[j]);
          if (v && v.indexOf(k) !== -1) { out.push(all[i]); break; }
        }
      }
      return out;
    }
    function swapAttrs(el, from, to) {
      ATTRS.forEach(function (a) {
        var v = el.getAttribute(a);
        if (v && v.indexOf(from) !== -1) el.setAttribute(a, v.split(from).join(to));
      });
    }
    function midOf(srcset) {
      var best = '', bd = 1e9;
      String(srcset || '').split(',').forEach(function (c) {
        var m = c.trim().match(/^(\S+)\s+(\d+)w$/), d;
        if (m) { d = Math.abs(+m[2] - MID); if (d < bd) { bd = d; best = m[1]; } }
      });
      return best;
    }
    function ready(im) { return !!(im && im.complete && im.naturalWidth); }
    var hold = null, pool = {};
    function box() {
      if (!hold) {
        hold = document.createElement('div');
        hold.setAttribute('aria-hidden', 'true');
        hold.style.cssText = 'position:fixed;left:-10000px;top:0;width:10px;height:10px;overflow:hidden;opacity:0;pointer-events:none;';
        document.body.appendChild(hold);
      }
      return hold;
    }
    // Pictures waiting in the box, per photo: its 600 px copy and its full size.
    function entry(k) { return pool[k] || (pool[k] = { mid: null, full: null }); }
    // The gallery's own picture of the option, as first drawn: the pattern every color's picture is made from.
    function pattern(g, fs) {
      if (!g.__mbvpTpl) {
        var k = shownKey(g, fs), im = k ? slideImg(g, k) : null;
        if (!im) return null;
        g.__mbvpTpl = { k: k, el: im.cloneNode(false) };
      }
      return g.__mbvpTpl;
    }
    function make(t, to, mid, pri) {
      var c = t.el.cloneNode(false), m;
      c.removeAttribute('id');
      swapAttrs(c, t.k, to);
      if (mid) {
        m = midOf(c.getAttribute('srcset'));
        if (!m) return null;
        c.setAttribute('srcset', m + ' ' + MID + 'w');
        c.setAttribute('src', m);
      }
      c.setAttribute('loading', 'eager');
      c.setAttribute('decoding', 'async');
      c.setAttribute('fetchpriority', pri);
      c.__mbvpKind = mid ? 'mid' : 'full';
      c.addEventListener('load', function () { if (c.decode) c.decode().catch(function () {}); }, { once: true });
      box().appendChild(c);
      return c;
    }
    function prep(g, fs, to, full, pri) {
      var t = pattern(g, fs), e;
      if (!t || !to) return null;
      e = entry(to);
      if (to === t.k && !e.full && !e.mid) return e;
      if (!e.mid && !e.full) e.mid = make(t, to, true, pri === 'high' ? 'high' : 'low');
      if (full && !e.full) e.full = make(t, to, false, pri || 'auto');
      return e;
    }
    // `next` takes the place of `cur` on screen; `cur` goes to the box, ready for a tap back.
    function place(cur, next) {
      if (!cur || !next || cur === next) return;
      next.className = cur.className;
      if (cur.hasAttribute('style')) next.setAttribute('style', cur.getAttribute('style'));
      if (cur.hasAttribute('alt')) next.setAttribute('alt', cur.getAttribute('alt'));
      var k = key(cur.getAttribute('src')), kind = cur.__mbvpKind || 'full';
      cur.replaceWith(next);
      cur.setAttribute('loading', 'eager');
      box().appendChild(cur);
      if (k) entry(k)[kind] = cur;
    }
    function eachOption(fn) {
      var ps = document.querySelectorAll('variant-picker'), i, j, g, fss, ks, from;
      for (i = 0; i < ps.length; i++) {
        if (!okPicker(ps[i]) || !(g = galleryOf(ps[i]))) continue;
        fss = ps[i].querySelectorAll('fieldset');
        for (j = 0; j < fss.length; j++) {
          ks = optionKeys(fss[j]);
          from = shownKey(g, fss[j]);
          if (from && ks.length <= IDLE_MAX) fn(g, fss[j], from, ks);
        }
      }
    }
    // The 600 px copies of every color first, then the full sizes one after the other, so the line stays free for
    // the page.
    function warmAll() {
      var queue = [];
      eachOption(function (g, fs, from, ks) {
        ks.forEach(function (k) { if (k !== from) { prep(g, fs, k, false, 'low'); queue.push([g, fs, k]); } });
      });
      var next = function () {
        var q = queue.shift(), e;
        if (!q) return;
        e = prep(q[0], q[1], q[2], true, 'low');
        if (!e || !e.full || ready(e.full)) { next(); return; }
        e.full.addEventListener('load', next, { once: true });
        e.full.addEventListener('error', next, { once: true });
      };
      setTimeout(next, 1500);
    }
    // Start once the gallery's first photo is in, so the page's own photos come first.
    function start() {
      var g = document.querySelector('media-gallery'), im = g && g.querySelector('slideshow-slide img'), n = 0;
      var go = function () { if (n++) return; (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(warmAll, { timeout: 2000 }); };
      if (!im || ready(im)) go();
      else { im.addEventListener('load', go, { once: true }); im.addEventListener('error', go, { once: true }); setTimeout(go, 4000); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    // The finger lands on a color: its photo starts loading now, before the tap ends.
    document.addEventListener('pointerdown', function (e) {
      var l = e.target && e.target.closest ? e.target.closest('variant-picker label') : null;
      var inp = l && l.querySelector('input[type=radio]'), p, g, fs;
      if (!inp || inp.checked || !okPicker(p = inp.closest('variant-picker'))) return;
      g = galleryOf(p);
      fs = inp.closest('fieldset');
      if (g && fs && shownKey(g, fs)) prep(g, fs, photoKey(inp), true, 'high');
    }, { capture: true, passive: true });
    // Same photos in both galleries, the option's photo aside.
    function samePhotos(g, g2, fs, to) {
      var a = slides(g), b = slides(g2), ks = optionKeys(fs), i, x, y;
      if (!a.length || a.length !== b.length) return false;
      for (i = 0; i < a.length; i++) {
        x = slideKey(a[i]);
        y = slideKey(b[i]);
        if (ks.indexOf(x) !== -1) x = '#option';
        if (ks.indexOf(y) !== -1) { if (y !== to) return false; y = '#option'; }
        if (x !== y) return false;
      }
      return true;
    }
    function copyTexts(g, g2, to) {
      var a = holders(g, to), b = holders(g2, to), i, ba, bb;
      if (!a.length || a.length !== b.length) return;
      for (i = 0; i < a.length; i++) {
        if (b[i].hasAttribute('alt')) a[i].setAttribute('alt', b[i].getAttribute('alt'));
        ba = a[i].closest('button');
        bb = b[i].closest('button');
        if (ba && bb && bb.hasAttribute('aria-label')) ba.setAttribute('aria-label', bb.getAttribute('aria-label'));
      }
    }
    // pass 46, for a gallery that does change: the theme's new gallery opens on the color's photo.
    function lead(r) {
      var d = r && r.detail, h = d && d.html, g = h && h.querySelector ? h.querySelector('media-gallery') : null;
      var fm = d && d.resource && d.resource.featured_media, f = file(fm && fm.preview_image && fm.preview_image.src);
      var ss = g && f ? g.querySelector('slideshow-component') : null, sl = ss ? ss.querySelectorAll('slideshow-slide') : [], i, im;
      for (i = 1; i < sl.length; i++) {
        im = sl[i].querySelector('img');
        if (im && file(im.getAttribute('src')) === f) {
          ss.setAttribute('initial-slide', String(i));
          if (!sl[i].getAttribute('slide-id')) sl[i].setAttribute('slide-id', 'mbvp-color-' + i);
          (function (gs, n) {
            requestAnimationFrame(function () {
              if (!document.documentElement.contains(gs)) return;
              var s = gs.querySelectorAll('slideshow-slide')[n], p = s && s.parentElement;
              if (!s || !p || !p.scrollTo) return;
              p.scrollTo({ left: s.offsetLeft - (p.firstElementChild ? p.firstElementChild.offsetLeft : 0), behavior: 'instant' });
            });
          })(ss, i);
          break;
        }
      }
    }
    var tapped = null, turn = 0;
    document.addEventListener('change', function (e) {
      var t = e.target;
      tapped = t && t.type === 'radio' && t.closest && t.closest('variant-picker') ? t : null;
    }, true);
    window.addEventListener('shopify:product:select', function (e) {
      var p = e.target, inp = tapped, g, fs, to, from, mine, state, en;
      tapped = null;
      if (!e.promise || !p || !p.closest || !p.closest('variant-picker') || !okPicker(p)) return;
      g = galleryOf(p);
      fs = inp && inp.closest ? inp.closest('fieldset') : null;
      to = fs && !inp.hasAttribute('data-mbvp-note') ? photoKey(inp) : '';
      from = g && to ? shownKey(g, fs) : '';
      if (!g || !to || (!from && slideIndex(g, to) < 0)) {
        try { e.promise = e.promise.then(function (r) { try { lead(r); } catch (x) {} return r; }); } catch (x) {}
        return;
      }
      mine = ++turn;
      state = { done: false, g2: null };
      en = from && from !== to && slideIndex(g, to) < 0 ? prep(g, fs, to, true, 'high') : null;
      function go() {
        if (state.done || mine !== turn || !document.documentElement.contains(g)) return;
        state.done = true;
        var now = shownKey(g, fs), e2 = entry(to), cur, pick, f, mid, up, k, ss;
        if (now && now !== to && slideIndex(g, to) < 0) {
          cur = slideImg(g, now);
          pick = ready(e2.full) ? e2.full : ready(e2.mid) ? e2.mid : null;
          holders(g, now).forEach(function (el) { if (el !== cur) swapAttrs(el, now, to); });
          if (pick) place(cur, pick);
          else if (cur) { try { cur.loading = 'eager'; } catch (x) {} swapAttrs(cur, now, to); }
          // The 600 px copy is on screen: the full size takes its place once it is in.
          if (pick && pick === e2.mid && e2.full) {
            f = e2.full;
            mid = e2.mid;
            up = function () { if (mine === turn && ready(f) && mid.isConnected && mid.parentNode !== hold) place(mid, f); };
            if (ready(f)) up(); else f.addEventListener('load', up, { once: true });
          }
        }
        k = slideIndex(g, to);
        ss = g.slideshow || g.querySelector('slideshow-component');
        if (k >= 0 && ss && ss.select) ss.select(k, undefined, { animate: false });
        if (state.g2) copyTexts(g, state.g2, to);
      }
      if (!en || ready(en.full) || ready(en.mid)) go();
      else {
        [en.mid, en.full].forEach(function (x) { if (x) { x.addEventListener('load', go, { once: true }); x.addEventListener('error', go, { once: true }); } });
        setTimeout(go, WAIT);
      }
      try {
        e.promise = e.promise.then(function (r) {
          try {
            var h = r && r.detail && r.detail.html, g2 = h && h.querySelector ? h.querySelector('media-gallery') : null;
            if (g2 && mine !== turn) g2.parentNode.removeChild(g2);
            else if (g2 && samePhotos(g, g2, fs, to)) {
              if (state.done) copyTexts(g, g2, to); else state.g2 = g2;
              g2.parentNode.removeChild(g2);
            } else if (g2) {
              state.done = true;
              lead(r);
            }
          } catch (x) {}
          return r;
        });
      } catch (x) {}
    }, true);
  })();
